import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCMLt26OEQI-p3iFBLv5dyAHe7iMwbUGas",
  authDomain: "paylora-84531.firebaseapp.com",
  projectId: "paylora-84531",
  storageBucket: "paylora-84531.firebasestorage.app",
  messagingSenderId: "442135270732",
  appId: "1:442135270732:web:adac33caa0471f859e6be9",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;